import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Footer from "./components/Footer";
import About from "./pages/About";
import Accommodation from "./pages/Accommodation";
import Dining from "./pages/Dining";
import Gallary from "./pages/Gallary";
import Contact from "./pages/Contact";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BookNow from "./pages/BookNow";
import KalutaraBodhiya from "./pages/explore/KalutaraBodhiya";
import KalutaraBeach from "./pages/explore/KalutaraBeach";
import RichmondCastle from "./pages/explore/RichmondCastle";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/dining" element={<Dining />} />
        <Route path="/gallery" element={<Gallary />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-condition" element={<TermsAndCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/book-now" element={<BookNow />} />

        <Route path="/kalutara-bodhiya" element={<KalutaraBodhiya />} />
        <Route path="/kalutara-beach" element={<KalutaraBeach />} />
        <Route path="/richmond-castle" element={<RichmondCastle />} />

      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
